// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heading{width:100%;color:#666b69;font-weight:var(--weight-medium);line-height:23px;text-align:center;text-transform:uppercase;font-size:12px;letter-spacing:5.33px;margin-top:80px;margin-bottom:32px}@media(min-width: 960px){.heading{font-size:16px;letter-spacing:7.11px;margin-top:108px}}@media(min-width: 1280px){.heading{margin-top:104px}}.heading--no-top-margin{margin-top:0}.heading--thin{font-weight:var(--weight-light)}", ""]);
// Exports
module.exports = exports;
